module.exports = __webpack_public_path__ + "img/2.9d1301d6.jpg";